import { render, staticRenderFns } from "./BatchClassic.vue?vue&type=template&id=0c101ba6&"
import script from "./BatchClassic.vue?vue&type=script&lang=js&"
export * from "./BatchClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports